/**
 * CourseFilterCollection
 *
 * @author ftgibran
 */
import {HttpExclude, RequestExpose} from 'simpli-web-sdk'
import {ErroIntegracaoCollection} from '@/model/collection/ErroIntegracaoCollection'
import {IErroIntegracaoResourcesHolder} from '@/interfaces/resource/IErroIntegracaoResourcesHolder'

@HttpExclude()
export class ErroIntegracaoFilterCollection extends ErroIntegracaoCollection {
  constructor() {
    super()
  }

  resource?: IErroIntegracaoResourcesHolder

  @RequestExpose() idResponsavel: number | null = null

  @RequestExpose() start: string | null = null
  @RequestExpose() end: string | null = null

  @RequestExpose() nroFiscal: string | null = null

  get responsavel() {
    return this.resource?.collectionResponsavel.getResource(this.idResponsavel)
  }
  set responsavel(input) {
    this.idResponsavel = input?.$id || null
  }
}
